import * as React from "react";
import {useState} from "react";
import {MockToolProps} from "./types";
import {classNames, layout, typography} from "@variocube/cube-ui";
import {Tool} from "./Tool";
import {useEffect} from "react";
import {Occupancy} from "@variocube/app-api";

export function PagerTool({mockController, align}: MockToolProps) {
    const [currentAccessCode, setCurrentAccessCode] = useState<string>();
    const [changed, setChanged] = useState<boolean>(false);

    const handleCurrentAccessCode = (occupancy: Occupancy) => {
        if(currentAccessCode !== occupancy.accessCode) {
            setChanged(true);
            setTimeout(() => {
                setChanged(false);
            }, 10000);
        }
        setCurrentAccessCode(occupancy.accessCode);
    };

    const clearAccessCode = () => {
        setCurrentAccessCode(undefined);
    };

    const occupancyCreatedListener = {
        created: handleCurrentAccessCode,
        updated: handleCurrentAccessCode,
        accessChanged: handleCurrentAccessCode,
        ended: clearAccessCode
    };

    const handleCopyClipboard = () => {
        if(currentAccessCode && navigator.clipboard) {
            navigator.clipboard.writeText(currentAccessCode).then();
            console.log(`Copied ${currentAccessCode} to clipboard`);
        }
    };

    useEffect(() => {
        mockController.addOccupancyListener(occupancyCreatedListener);
    }, [mockController]);

    return (
        <Tool label="Pager" highlight={changed} align={align}>
            <div className={classNames(layout.paddingMedium, layout.vertical, layout.alignCenter, layout.fill)} style={{minWidth: '25em'}}>
                {currentAccessCode &&
                    <>
                        <div className={typography.caption}>Current access code</div>
                        <div className={classNames(typography.bigger, typography.monospace)} style={{cursor: 'pointer'}} onClick={handleCopyClipboard}>
                            {currentAccessCode}
                        </div>
                    </>
                }
                {!currentAccessCode &&
                    <div className={typography.caption}>The pager will light up after you have stored something.</div>
                }
            </div>
        </Tool>
    );
}